import { createSelector } from 'reselect';

const selector = (state, projectId) => {
  return state.tasks.items.filter(i => i.project_id === projectId)
                          .asMutable({ deep: true });
}

export default createSelector(
  [selector], result => result
)



// WEBPACK FOOTER //
// ./src/selectors/tasks-selector.js